export default __webpack_public_path__ + "static/media/co2.fb692a79.svg";